import { atom } from 'recoil';

export const createdExerciseAtom = atom({
  key: 'createdExerciseAtom',
  default: 0,
});
